// extracted by mini-css-extract-plugin
export default {"module":"LiquidityPositionsModule_module__d+v5L","title":"LiquidityPositionsModule_title__Z07fM","liquidityPositions":"LiquidityPositionsModule_liquidityPositions__dvs7q"};